var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"gift-deposit-element",attrs:{"target":"_blank"}},[_c('img',{attrs:{"src":require('@/assets/img/cashier/gift/gift_' + _vm.amount + '.webp')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }